module.exports = __webpack_public_path__ + "img/bodine.69109c61.jpg";